import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TimeInputField from '../TimeInputField';
import DownArrow from '../../images/dropdown_arrow_copy_2.svg';

const CustomStylePickerStyled = styled.div`
    position: relative;
`;

const LabelStyled = styled.label`
    position: absolute;
    left: 13px;
    top: 13px;
    font-size: 14px;
    color: #bcaaa3;
    transition: all 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 1px;
`;

const TimePickerStyled = styled.div`
    height: 320px;
    z-index: 1;
    position: absolute;
    background: white;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.15);
    border-radius: 2px;
    display: ${props => props.show ? 'flex' : 'none'};
    justify-content: center;
    color: #3E2723;
    width: 100%;
    padding: 0 12px 20px 12px;
    font-size: 16px;
    
    >div {
        font-family: IntroBold;
        border-bottom: .5px solid #C5B3AF;
    }
`;

const InputStyled = styled.div`
    background: inherit;
    position: relative;
    margin-bottom: 0;
    margin-top: 28px;
    padding: 0;
    
    input {
        width: 100%;
        line-height: 26px;
        background: transparent;
        border: none;
        border-bottom-width: 1px;
        border-bottom-style: solid;
        border-bottom-color: #bcaaa3;
        border-radius: 0;
        box-shadow: none;
        padding: 10px 13px 3px 13px;
        font-family: IntroBold;
        font-size: 17.5px;
        color: #3e2723;
    }
      
    .show, input:focus + label {
        top: -12px;
        font-size: 10.5px;
    }
    
    input:focus + label {
        color: #04A2DC;
    }
    
    .show {
        color: #BCAAA3;
    }
    
    input:focus {
        border-bottom-color: #04A2DC;
    }
    
    img {
        position: absolute;
        top: 20px;
        right: 15px;
    }
   
`;

const TimeDivStyled = styled.div`
    overflow: scroll;
    height: 260px;
    
    .selected-time {
        color: white !important;
        background-color: #3e2723 !important;
    }
`;

const SelectableDiv = styled.div`
    width: 36px;
    height: 36px;
    margin: 3px 17px;
    text-align: center;
    padding: 10px 7px;
    border: 0;
    border-radius: 50%;
    
    &:hover {
       background-color: #C5B3AF;
    } 
`;

const HeaderDiv = styled.div`
    text-align: center;
    font-size: 13px;
    text-transform: uppercase;
    width: 70px;
    padding: 10px 7px;
    color: #C5B3AF;
    border-bottom: .5px solid #C5B3AF;
`;

class CustomTimePicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value,
            showTime: !!props.value,
            hour: '',
            minute: '',
            amPm: '',
            showTimePicker: false,
            isPopulated: !!(props.value)
        };
    }

    componentDidMount() {
        window.addEventListener('click', this.timePickerToggle);
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.timePickerToggle);
    }

    timePickerToggle = (e) => {
        if (!document.getElementById('custom_time_picker').contains(e.target)) {
            this.setState({ showTimePicker: false });
        }
    };

    timeHandler = () => {
        if (!this.state.showTime) {
            const now = new Date();
            let amPm;
            let hour = now.getHours();

            if (hour === 0) {
                amPm = 'AM';
                hour = 12;
            } else if (hour === 12) {
                amPm = 'PM';
            } else if (hour > 12) {
                amPm = 'PM';
                hour -= 12;
            } else {
                amPm = 'AM';
            }

            let minute = now.getMinutes();
            if (minute < 10) {
                minute = `0${minute}`;
            } else {
                minute += '';
            }

            this.setState({
                showTime: true,
                showTimePicker: true,
                value: `${hour < 10 ? '0' : ''}${hour}:${minute} ${amPm}`,
                hour: `${hour < 10 ? '0' : ''}${hour}`,
                minute,
                amPm
            }, () => {
                this.props.handleTimeChange(this.state.value);
                this.scrollIntoView();
            });
        } else if (!this.state.showTimePicker) {
            this.setState({ showTimePicker: true }, this.scrollIntoView);
        }
    };

    onTimeInputChange = (value) => {
        let hour = value.slice(0, 2);
        if (parseInt(hour, 10) > 23) {
            hour = '12';
        }

        this.setState({
            value,
            hour,
            minute: value.slice(3, 5),
            amPm: value.slice(6, 8),
            isPopulated: true
        }, () => {
            this.props.handleTimeChange(value);
            this.scrollIntoView();
        });
    };

    scrollIntoView = () => {
        Array.from(document.querySelectorAll('.selected-time')).forEach((element) => {
            element.scrollIntoView();
            window.scrollBy(0, -300);
        });
    };

    setTime = (newTime) => {
        const newState = this.stateTimeHandler[newTime.key](newTime.value, this.state);
        this.setState(newState, () => {
            this.props.handleTimeChange(newState.value);
        }
        );
    };

    hideTimePicker = () => {
        this.setState({ showTimePicker: false });
    };

    stateTimeHandler = {
        hour(value, state) {
            return {
                hour: value,
                value: `${value}:${state.minute} ${state.amPm}`
            };
        },
        minute(value, state) {
            return {
                minute: value,
                value: `${state.hour}:${value} ${state.amPm}`
            };
        },
        amPm(value, state) {
            return {
                amPm: value,
                value: `${state.hour}:${state.minute} ${value}`
            };
        }
    };

    getLocalizedLabel() {
        const TimeOfVisitSansFormat = this.props.getLocalizedText('TimeOfVisit', 'time of visit').split('(');
        return `${TimeOfVisitSansFormat[0]} (${this.props.getLocalizedText('Optional', 'optional').trim()})`;
    }

    render() {
        const showTimePicker = this.state.showTimePicker;
        const show = this.state.value ? 'show' : '';

        const amPm = [
            <SelectableDiv className={this.state.amPm === 'AM' ? 'selected-time' : ''}
                           onClick={() => { this.setTime({ key: 'amPm', value: 'AM' }); }}
                           key="am">AM</SelectableDiv>,
            <SelectableDiv className={this.state.amPm === 'PM' ? 'selected-time' : ''}
                           onClick={() => { this.setTime({ key: 'amPm', value: 'PM' }); }}
                           key="pm">PM</SelectableDiv>
        ];

        const hours = [
            <SelectableDiv className={this.state.hour === '12' ? 'selected-time' : ''}
                           onClick={() => { this.setTime({ key: 'hour', value: '12' }); }}
                           key="hour_12">12</SelectableDiv>
        ];
        for (let i = 1; i < 12; i++) { // eslint-disable-line no-plusplus
            i = `${i < 10 ? '0' : ''}${i}`;
            hours.push(<SelectableDiv className={this.state.hour === i ? 'selected-time' : ''}
                                      onClick={() => { this.setTime({ key: 'hour', value: i }); }}
                                      key={`hour_${i}`}>{i}</SelectableDiv>);
        }

        const minutes = [];
        for (let j = 0; j < 60; j++) { // eslint-disable-line no-plusplus
            if (j < 10) { j = `0${j}`; } else { j += ''; }
            minutes.push(<SelectableDiv className={this.state.minute === j ? 'selected-time' : ''}
                                        onClick={() => { this.setTime({ key: 'minute', value: j }); }}
                                        key={`minute_${j}`}>{j}</SelectableDiv>);
        }

        return (
            <CustomStylePickerStyled id='custom_time_picker'>
                <InputStyled onClick={this.timeHandler}>
                    <TimeInputField value={this.state.value}
                                    onChange={this.onTimeInputChange}/>
                    <LabelStyled className={show}
                                 htmlFor='time-input-field' >
                        { this.getLocalizedLabel() }
                    </LabelStyled>
                    <img alt="" src={DownArrow}/>
                </InputStyled>
                <TimePickerStyled show={showTimePicker}
                                  onBlur={this.hideTimePicker}>
                    <div>
                        <HeaderDiv>
                            {this.props.getLocalizedText('Hour', 'Hour')}
                        </HeaderDiv>
                        <TimeDivStyled>
                            {hours}
                        </TimeDivStyled>
                    </div>
                    <div>
                        <HeaderDiv>
                            {this.props.getLocalizedText('Minute', 'Minute')}
                        </HeaderDiv>
                        <TimeDivStyled>
                            {minutes}
                        </TimeDivStyled>
                    </div>
                    <div>
                        <HeaderDiv>
                            {this.props.getLocalizedText('Ampm', 'AM/PM')}
                        </HeaderDiv>
                        <TimeDivStyled>
                            {amPm}
                        </TimeDivStyled>
                    </div>
                </TimePickerStyled>
            </CustomStylePickerStyled>
        );
    }
}

CustomTimePicker.propTypes = {
    value: PropTypes.string,
    handleTimeChange: PropTypes.func.isRequired,
    getLocalizedText: PropTypes.func.isRequired
};

CustomTimePicker.defaultProps = {
    value: '',
    handleTimeChange: () => {},
    getLocalizedText: (key, defaultValue) => defaultValue
};

export default CustomTimePicker;



// WEBPACK FOOTER //
// ./src/components/CustomTimePicker/index.js